import type { FileUploadController } from "@msuite/ui/file-upload";
import { Panels } from "@msuite/ui/panels";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { ProtocolFormContext } from "./context";
import { ProtocolFormAttachments } from "./protocol-form-attachments";
import { ProtocolFormBasics } from "./protocol-form-basics";
import { ProtocolFormContent } from "./protocol-form-content";
import { ProtocolFormFooter } from "./protocol-form-footer";
import { ProtocolFormRecipients } from "./protocol-form-recipients";
import { ProtocolFormTime } from "./protocol-form-time";
import { ProtocolFormTypeCallRequestDetails } from "./protocol-form-type-call-request-details";

/** Props Interface */
interface ProtocolFormProps {
	controller: FileUploadController;
}

export function ProtocolForm({ controller }: ProtocolFormProps) {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const type = useWatch({ control: methods.control, name: "type" });

	/** Computed */
	const hasType = Boolean(type);

	/** Render */
	return (
		<ProtocolFormContext.Provider value={{ hasType, type }}>
			<Panels className="flex-1">
				<Panels.Panel
					flex={2}
					className="pb-4"
				>
					<ProtocolFormBasics />
					<ProtocolFormTypeCallRequestDetails />
					<ProtocolFormContent />
				</Panels.Panel>
				<Panels.Panel
					className="pb-4 grid grid-rows-[1fr_auto] gap-4"
					flex={1}
				>
					<div className="v-stack overflow-auto scrollbar-hidden gap-4">
						<ProtocolFormRecipients />
						<ProtocolFormTime />
						<ProtocolFormAttachments controller={controller} />
					</div>
					<ProtocolFormFooter />
				</Panels.Panel>
			</Panels>
		</ProtocolFormContext.Provider>
	);
}
